angular.module('project')
    .component('projectShow', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/project/show.html',
        controller: function ($scope, $rootScope, $http, $httpParamSerializer, $state, $window, Project, ProjectService, Principal, modals) {
            this.ProjectService = ProjectService;

            this.$onInit = () => {
                this.canReadWorkflow = Principal.hasAnyAuthority(["ROLE_WORKFLOW_MODULE"]);
                this.canReadPowerOfAttorney = Principal.hasAnyAuthority(["ROLE_POWER_OF_ATTORNEY_MODULE"]);
                this.canReadServiceRequests = Principal.hasAnyAuthority(["ROLE_SERVICE_REQUEST"]);
                this.canReadInvoice = Principal.hasAnyAuthority(["ROLE_INVOICE_DOCUMENTS_MODULE"]);
                this.canReadAgreements = Principal.hasAnyAuthority(["ROLE_CONTRACT_MODULE"]);
                this.canReadOrders = Principal.hasAnyAuthority(["ROLE_CONTRACT_MODULE"]);
                this.canReadOffers = Principal.hasAnyAuthority(["ROLE_ADMIN"]);
                this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']);
                this.canReadPropertyPriceTransparency = Principal.hasAnyAuthority(['ROLE_PROPERTY_PRICE_TRANSPARENCY']);
            }

            this.searchDocs = () => {
                this.query = this.searchQuery
            }

            this.resetSearch = () => {
                this.searchQuery = null;
                this.searchDocs()
            }

            this.onWorkflowLoaded = page => this.workflowCount = page.fullListSize || 0
            this.onPowerOfAttorneyLoaded = page => this.powerOfAttorneyCount = page.fullListSize || 0
            this.onServiceRequestLoaded = page => this.serviceRequestCount = page.fullListSize || 0
            this.onInvoiceLoaded = page => this.invoiceCount = page.fullListSize || 0
            this.onAgreementLoaded = page => this.agreementCount = page.fullListSize || 0
            this.onOrderLoaded = page => this.orderCount = page.fullListSize || 0
            this.onOfferLoaded = page => this.offerCount = page.fullListSize || 0

            this.sendTransparency = () => {
                return $http.post("/crm/api/property-price-transparency/" + this.item.id + "/send")
                    .then(() => {
                        toastr.success("Aktualny plik CSV projektu " + this.item.name + " wysłano na FTP");
                    }).catch(() => {
                        toastr.error("Nie udało się wysłać pliku CSV na FTP");
                    });
            }

            this.sendGovFtp = (params) => {
                return $http.post("/crm/api/property-price-transparency/" + this.item.id + "/gov?" + $httpParamSerializer(params))
                    .then(() => {
                        toastr.success(params && params.forceAgain ? "Ponowiono dzisiejszą publikację dla dane.gov.pl" : "Opublikowano dzisiejsze dane dla dane.gov.pl");
                    }).catch(() => {
                        toastr.error(params && params.forceAgain ? "Nie udało się ponowić dzisiejszej publikacji" : "Nie udało się opublikować dzisiejszych danych");
                    });
            }

            this.openGovPublicationModal = () => modals.open('app/project/transparency-publication-modal.html', 'ProjectTransparencyPublicationController', {id: this.item.id, name: this.item.name}, {size: 'sm'}, '$ctrl')

            this.generateMd5Ftp = (params) => {
                return $http.post("/crm/api/property-price-transparency/" + this.item.id + "/generate-md5?" + $httpParamSerializer(params))
                    .then(() => {
                        toastr.success("Przeliczono, wysłano i zweryfikowano plik MD5");
                    }).catch(() => {
                        toastr.error("Nie udało się przeliczyć i wysłać pliku MD5");
                    });
            }

            this.getExportUrlForProjectPriceTransparency = (params) => {
                return "/crm/api/property-price-transparency/" + this.item.id + "/export?" + $httpParamSerializer(params)
            }

            this.cancel = () => $window.history.back();

            $scope.$on(Project.eventUpdate, () => {
                $rootScope.$broadcast('document.comments.reload', this.item.id)
                $state.reload();
            })
            $scope.$on(Project.eventDelete, () => this.cancel())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
